"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MedplanLisTtable = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledTable = (0, _styles.styled)(_Table.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  };
});
const StyledTableHead = (0, _styles.styled)(_TableHead.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    '& th': {
      background: theme.palette.table.header.primary.main,
      color: theme.palette.table.header.primary.contrastText,
      fontWeight: 'normal',
      paddingLeft: 0,
      paddingRight: 0
    }
  };
});
const StyledHeadCell = (0, _styles.styled)(_TableCell.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    borderLeft: 'solid 1px',
    borderLeftColor: theme.palette.border.white
  };
});
const StyledTableBody = (0, _styles.styled)(_TableBody.default)(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    '& td': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  };
});
const StyledTableRow = (0, _styles.styled)(_TableRow.default)(_ref5 => {
  let {
    theme
  } = _ref5;
  return {
    background: theme.palette.table.body.primary.main,
    '&.pastYear': {
      background: '#d6dbe1'
    },
    '&.nowYear': {
      background: '#afeeee'
    }
  };
});
const StyledDataCell = (0, _styles.styled)(_TableCell.default)(_ref6 => {
  let {
    theme
  } = _ref6;
  return {
    whiteSpace: 'pre-line',
    borderRight: '1px solid #CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    fontSize: theme.typography.body2.fontSize,
    '& .MuiTypography-root': {
      fontSize: 'inherit',
      lineHeight: 'inherit'
    }
  };
});
const StyledNoRegCell = (0, _styles.styled)(_TableCell.default)(_ref7 => {
  let {
    theme
  } = _ref7;
  return {
    borderBottom: '1px solid #CCCCCC',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1.4,
    '& .MuiTypography-root': {
      fontSize: 'inherit',
      lineHeight: 'inherit'
    }
  };
});

/**
 * 訓練中期計画一覧テーブルコンポーネント
 */
class MedplanLisTtable extends _react.default.Component {
  render() {
    const {
      columns,
      rowData,
      createRow
    } = this.props;
    const rows = rowData.map((data, index) => {
      return createRow(data, index);
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledTable, null, /*#__PURE__*/_react.default.createElement(StyledTableHead, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, columns.map((column, index) => {
      return /*#__PURE__*/_react.default.createElement(StyledHeadCell, {
        key: 'header_' + index,
        width: column.width
      }, column.label);
    }))), /*#__PURE__*/_react.default.createElement(StyledTableBody, null, rowData.map((data, index) => {
      const rowClass = (rows[index].pastYearFlg ? 'pastYear ' : '') + (rows[index].nowYearFlg ? 'nowYear' : '');
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(StyledTableRow, {
        className: rowClass
      }, rows[index].pastRegisterdFlg ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDataCell, null, rows[index].kunrenNendo), /*#__PURE__*/_react.default.createElement(StyledDataCell, null, rows[index].targetRisk), /*#__PURE__*/_react.default.createElement(StyledDataCell, null, rows[index].kunrenPeriod), /*#__PURE__*/_react.default.createElement(StyledDataCell, null, rows[index].kunrenPurpose), /*#__PURE__*/_react.default.createElement(StyledDataCell, null, rows[index].notes)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledNoRegCell, null, rows[index].kunrenNendo), /*#__PURE__*/_react.default.createElement(StyledNoRegCell, null, rows[index].targetRisk), /*#__PURE__*/_react.default.createElement(StyledNoRegCell, null, rows[index].kunrenPeriod), /*#__PURE__*/_react.default.createElement(StyledNoRegCell, null, rows[index].kunrenPurpose), /*#__PURE__*/_react.default.createElement(StyledNoRegCell, null, rows[index].notes))));
    }))));
  }
}
exports.MedplanLisTtable = MedplanLisTtable;
var _default = exports.default = (0, _reactIntl.injectIntl)(MedplanLisTtable);